import { useTranslation } from 'react-i18next';

import Product from 'components/product/Product';
import {getData} from 'components/product/util';

import img1 from 'assets/images/solutions/inverters/hd/inverter_1.png'
import img2 from 'assets/images/solutions/inverters/hd/inverter_2.jpg'
import img3 from 'assets/images/solutions/inverters/hd/inverter_3.jpg'
export default function ProductHd(){
  const {t} = useTranslation();
  const products = getData(t, "inverters", "hd");
 
  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];
  products[1].images = [img2];
  products[2].images = [img3];

  return (
    <Product products={products}/>
  );
}